export default __webpack_public_path__ + "static/media/img-download.36120a7b.svg";